import { render, staticRenderFns } from "./RecurrencesCollection.vue?vue&type=template&id=4be93368&"
import script from "./RecurrencesCollection.vue?vue&type=script&lang=js&"
export * from "./RecurrencesCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports